/*eslint-disable */

import { bus } from '@/main';
import { mapGetters } from 'vuex';
import removeCandidatePopup from '../remove-candidate-info-popup/';

export default {
  name: 'candidate-list-screen',
  components: {
    'remove-candidate-info-popup' : removeCandidatePopup,
  },
  props: [],
  data () {
    return {
      candiDateListData:null,
      candiDateListRslts:[],
      removeCandidatePopupState:false,
      removeCandidateId:'',
      candidateLinkagePopupState:false,
      candidateLinkageId:''
    }
  },
  computed: {
    ...mapGetters([
      'getInViewerCandidateListGetter',
    ]),
    getCandidateListFun(){
     this.candiDateListData = this.$store.getters.getInViewerCandidateListGetter.data
     return 
    },
    setInintialState(){
      if(this.candiDateListData){
        this.candiDateListRslts = this.candiDateListData.results;
      }
      return;
    }
  },
  mounted () {
    this.getCandidateListFun;
    this.setInintialState;
    bus.$on('removeCandidatePopupStateBus', (data) => {
      this.removeCandidatePopupState = data
    })
    bus.$on('candidateLinkagePopupStateBus', (data) => {
      this.candidateLinkagePopupState = data
    })
  },
  methods: {
    candidateLinkagePopupMethod(id){
      this.candidateLinkagePopupState = true
      this.candidateLinkageId = id
      document.body.classList.add('body_right_scroll_remove')
    },
    removeCandidateInfoMethod(id){
      this.removeCandidateId = id
      this.removeCandidatePopupState = true
      document.body.classList.add('body_right_scroll_remove')
    }
  },
  watch: {
    getCandidateListFun(){
      return this.$store.getters.getInViewerCandidateListGetter; 
    },
    setInintialState(){
      if(this.candiDateListData){
        this.candiDateListRslts = this.candiDateListData.results;
      }
      return;
    }
  },
}